export const ROLES_KEY = 'roles';
export const ADMINISTRATOR = 'ADMINISTRATOR';
export const INSTRUCTOR = 'INSTRUCTOR';
export const CONTENT_CREATOR = 'CONTENT_CREATOR';
